const ROOM_TYPE = {
  PRIVATE: "Private",
  PUBLIC: "Public",
}

const APPLICATION_NAME = "Workflo";

const PRIORITY_COLORS = {
  p1: '#ff3e3e',
  p2: '#FF792E',
  p3: '#01A894',
  p4: '#0473CC',
  s1: '#FE3C32',
  s2: '#F4BF00',
  s3: 'yellow',
  s4: '#0074cc',
};

const PRIORITY_LABEL = {
  p1: 'Critical',
  p2: 'High',
  p3: 'Medium',
  p4: 'Low',
};

const PRIORITY_ICON = {
  p1: 'priority-critical',
  p2: 'priority-high',
  p3: 'priority-medium',
  p4: 'priority-low',
};


const COLOUR_PALETTE = [
  '#16a34a', '#22c55e', '#84cc16', '#ca8a04', '#eab308', '#f97316',
  '#0f766e', '#06b6d4', '#92400e', '#b45309', '#ea580c', '#f87171',
  '#1e6fb5', '#3b82f6', '#5a9fd4', '#991b1b', '#ef4444', '#ec4899',
  '#0e7490', '#38bdf8', '#4b8b9e', '#7c3aed', '#a855f7', '#f472b6',
  '#1d4ed8', '#4f46e5', '#6366f1', '#8b5cf6', '#e879f9', '#fb7185',
  '#0d9488', '#059669', '#475569', '#9ca3af', '#64748b', '#94a3b8',
];

const COLOURS = COLOUR_PALETTE;
const PROJECT_ICON_COLOURS = COLOUR_PALETTE;


const taskPriority = [
  {
    name: '--',
    rank: 'nill',
    color: ''
  },
  {
    name: PRIORITY_LABEL.p1,
    rank: 'p1',
    color: PRIORITY_COLORS.p1
  },
  {
    name: PRIORITY_LABEL.p2,
    rank: 'p2',
    color: PRIORITY_COLORS.p2
  },
  {
    name: PRIORITY_LABEL.p3,
    rank: 'p3',
    color: PRIORITY_COLORS.p3
  },
  {
    name: PRIORITY_LABEL.p4,
    rank: 'p4',
    color: PRIORITY_COLORS.p4
  }
]

const taskStatus = {
  allTasks: {
    key: 'all-tasks',
    label: 'All tasks'
  },
  completedTasks:
  {
    key: 'completed-tasks',
    label: 'Completed tasks'
  },
  incompletedTasks: {
    key: 'incompleted-tasks',
    label: 'Incompleted tasks',
  }
}

const dueDateFilterOptions = {
  allTasks: {
    key: 'all-tasks',
    label: 'Any time'
  },
  dueToday: {
    key: 'today',
    label: 'Today'
  },
  dueThisWeek: {
    key: 'this-week',
    label: 'This week'
  },
  dueThisMonth:
  {
    key: 'this-month',
    label: 'This month'
  }
}

const lastUpdatedFilterOptions = {
  allTasks: {
    key: 'all-tasks',
    label: 'Any time'
  },
  dueToday: {
    key: 'today',
    label: 'Today'
  },
  dueThisWeek: {
    key: 'this-week',
    label: 'This week'
  },
  dueThisMonth:
  {
    key: 'this-month',
    label: 'This month'
  }
}

const customFieldTypes = {
  dropdown: 'dropdown',
  text: 'text',
  assignee: 'assignee',
  date: 'date',
  number: 'number',
  status: 'status',
  priority: 'priority',
  cost: 'cost',
  link: 'link',
  multiSelect: 'multi-select',
  email: 'email',
  rating: 'rating',
  phone: 'phone',
  longText: 'long text',
  richText: 'rich text',
  currency: 'currency',
  address: 'address',
  checkbox: 'checkbox',
  idReference: 'id-reference',
  fullName: 'full-name',
  color: 'color',
  signature: 'signature',
  datetime: 'datetime',
  time: 'time',
  percentage: 'percentage',
  country: 'country',
  fileUpload: 'file-upload',
  camera: 'camera',
}

const accessStatus = {
  view: 'View',
  join: 'Join',
  request: 'Ask to join'
}

const fieldTypes = [
  {
    label: 'Status',
    key: 'status',
    color: '#7D3AD8',
    description: 'Indicates current state of a project',
    icon: 'notes.svg',
    options: [
      {
        key: 'to-do-statue',
        label: 'To Do',
        metadata: {
          color: 'red'
        }
      },
      {
        key: 'blocked-statue',
        label: 'Blocked',
        metadata: {
          color: 'red'
        }
      },
      {
        key: 'progress-statue',
        label: 'In Progress',
        metadata: {
          color: 'red'
        }
      },
      {
        key: 'review-statue',
        label: 'In Review',
        metadata: {
          color: 'red'
        }
      },
      {
        key: 'done-statue',
        label: 'Done',
        metadata: {
          color: 'red'
        }
      }
    ]
  },
  // {
  //   label: 'Assignee',
  //   key: 'assignee',
  //   color: '#bf74d6',
  //   description: 'Pick assigned team member',
  //   icon: 'User.svg'
  // },
  {
    label: 'Link',
    key: 'link',
    color: '#FF9900',
    description: 'Link to external page',
    icon: 'paper-pin.svg'
  },
  {
    label: 'Date',
    key: 'date',
    color: '#FF6969',
    description: 'Add a custom date for tracking deadlines',
    icon: 'date.svg'
  },
  {
    label: 'Text',
    key: 'text',
    color: '#00A099',
    description: 'Enter custom text to your workflow',
    icon: 'Text.svg'
  },
  {
    label: 'Dropdown',
    key: 'dropdown',
    color: '#EE3535',
    description: 'Select from custom predefined options',
    icon: 'dropdown.svg'
  },
  {
    label: 'Priority',
    key: 'priority',
    color: '#FF792E',
    description: 'Set task importance levels',
    icon: 'Flag.svg'
  },
  {
    label: 'Number',
    key: 'number',
    color: '#FF3823',
    description: 'Custom input of numerical values',
    icon: 'Hashtag.svg'
  },
  {
    label: 'Cost',
    key: 'cost',
    color: '#0473cc',
    description: 'Track expenses or costs related to tasks',
    icon: 'dollar.svg'
  },
  {
    label: 'Multi-Select',
    key: 'multi-select',
    color: '#ba1479',
    description: 'Select multiple options from the predefined list',
    icon: 'multiselect-dropdown.svg'
  },
  {
    label: 'Email',
    key: 'email',
    color: '#3F52F6',
    description: 'Capture emails for communication',
    icon: 'email.svg'
  },
  {
    label: 'Rating',
    key: 'rating',
    color: '#FFB800',
    description: 'Add and track ratings or scores',
    icon: 'star-filled.svg',
  },
  {
    label: 'Phone',
    key: 'phone',
    color: '#523f9e',
    description: 'Store and manage phone numbers',
    icon: 'mobile.svg',
  },
  {
    label: 'Long Text',
    key: 'long text',
    color: '#006400',
    description: 'Store detailed notes or long text',
    icon: 'long-text.svg',
  },
  {
    label: 'Rich Text',
    key: 'rich text',
    color: '#228B22',
    description: 'Write notes with formatting styles',
    icon: 'rich-text.svg',
  },
  {
    label: 'Checkbox',
    key: 'checkbox',
    color: '#0369a1',
    description: 'Simple yes or no toggle for binary flags and approvals',
    icon: 'tick.svg',
  },
  // {
  //   label: 'People',
  //   key: 'people',
  //   color: '#0891b2',
  //   description: 'Link field value to a workspace member',
  //   icon: 'members.svg',
  // },
  // {
  //   label: 'Formula',
  //   key: 'formula',
  //   color: '#7c3aed',
  //   description: 'Read-only value calculated from other numeric fields',
  //   icon: 'add-chart.svg',
  // },
  {
    label: 'Full Name',
    key: 'full-name',
    color: '#0f766e',
    description: 'Capture a persons first and last name',
    icon: 'contact.svg',
  },
  {
    label: 'Address',
    key: 'address',
    color: '#b45309',
    description: 'Store a full street address including city, state and postal code',
    icon: 'pin.svg',
  },
  {
    label: 'Date & Time',
    key: 'datetime',
    color: '#dc2626',
    description: 'Capture a date with an exact time, for appointments and events',
    icon: 'alarm.svg',
  },
  {
    label: 'Time',
    key: 'time',
    color: '#4F46E5',
    description: 'Record a time of day in 12-hour format with AM/PM',
    icon: 'alarm.svg',
  },
  {
    label: 'Currency',
    key: 'currency',
    color: '#16a34a',
    description: 'Numeric value with a selectable currency symbol',
    icon: 'dollar.svg',
  },
  {
    label: 'Percentage',
    key: 'percentage',
    color: '#ea580c',
    description: 'Number displayed as a percentage from 0 to 100',
    icon: 'Chart.svg',
  },
  // {
  //   label: 'Duration',
  //   key: 'duration',
  //   color: '#7e22ce',
  //   description: 'Track time spans in hours and minutes for effort or logging',
  //   icon: 'clock.svg',
  // },
  {
    label: 'ID / Reference',
    key: 'id-reference',
    color: '#475569',
    description: 'Auto-generated or manually entered reference number for tracking',
    icon: 'Hashtag.svg',
  },
  {
    label: 'Country',
    key: 'country',
    color: '#0c4a6e',
    description: 'Select a country from a standard predefined list',
    icon: 'pin.svg',
  },
  {
    label: 'Color',
    key: 'color',
    color: '#e11d48',
    description: 'Pick a color value using a color picker',
    icon: 'color-palete.svg',
  },
  {
    label: 'File Upload',
    key: 'file-upload',
    color: '#92400e',
    description: 'Attach one or more files directly to this field',
    icon: 'Upload.svg',
  },
  {
    label: 'Photo Capture',
    key: 'camera',
    color: '#1d4ed8',
    description: 'Take a photo with your camera or upload an image from your device',
    icon: 'camera.svg',
  },
  {
    label: 'Signature',
    key: 'signature',
    color: '#701a75',
    description: 'Capture a drawn e-signature for approvals and consent',
    icon: 'Edit.svg',
  },
]

const sectionColors = [
  {
    key: 0,
    bg: '#FEF5E7',
    border: '#F9E6CA'
  },
  {
    key: 1,
    bg: '#F4FDF8',
    border: '#CBF4DD'
  },
  {
    key: 2,
    bg: '#FFE5E1',
    border: '#FFD2CB'
  },
  {
    key: 3,
    bg: '#F2FAFC',
    border: '#DBEDF6'
  },
  {
    key: 4,
    bg: '#F1EFFF',
    border: '#DBD6F7'
  },
]

const sectionThemeColors = [
  '#F9E6CA',
  '#CBF4DD',
  '#FFD2CB',
  '#DBEDF6',
  '#F7EEC2',
  '#C7EDD7',
  '#F5D3E2',
  '#CFE4F4',
  '#E1D5F1',
  '#DDEACD',
  '#F9D8D3',
  '#CFE3E2',
  '#F8DCD0',
];

const ASANA_MIGRATION_VOID_COLORS = [
  'none',
  'cool-gray',
  'yellow-orange',
  'yellow-green',
  'blue-green',
  // aqua  
  // blue  
  // indigo  
  // purple  
  // magenta  
  'hot-pink'
  // pink  
]

const DASHBOARD_CHART_COLORS = [
  '#9ca3af', '#ef4444', '#f97316', '#f59e0b',
  '#eab308', '#84cc16', '#22c55e', '#10b981',
  '#06b6d4', '#3b82f6', '#8b5cf6', '#a855f7',
  '#ec4899', '#f43f5e', '#fb7185', '#6b7280'
];

const DASHBOARD_COLOR_PALETTES = [
  // 0. Indigo Scale (Anchor: #4F46E5)
  [
    '#6366F1',
    '#4F46E5',
    '#4338CA',
    '#3730A3',
    '#312E81',
    '#1E1B4B',
    '#1E134D',
    '#110D3D',
    '#0F0B30',
  ],
  // 1. Emerald Scale (Anchor: #10B981)
  [
    '#059669',
    '#10B981',
    '#047857',
    '#065F46',
    '#064E3B',
    '#022C22',
    '#011915',
    '#00100D',
    '#000806',
  ],
  // 2. Amber Scale (Anchor: #F59E0B)
  [
    '#FCD34D',
    '#F59E0B',
    '#D97706',
    '#B45309',
    '#92400E',
    '#78350F',
    '#652C0D',
    '#50230A',
    '#451D08',
  ],
  // 3. Red Scale (Anchor: #EF4444)
  [
    '#DC2626',
    '#EF4444',
    '#B91C1C',
    '#991B1B',
    '#7F1D1D',
    '#630D0D',
    '#4F0707',
    '#3B0404',
    '#2C0202',
  ],
  // 4. Violet Scale (Anchor: #8B5CF6)
  [
    '#7C3AED',
    '#8B5CF6',
    '#6D28D9',
    '#5B21B6',
    '#4C1D95',
    '#3C1575',
    '#2C0F55',
    '#1B0835',
    '#110520',
  ],
  // 5. Pink Scale (Anchor: #EC4899)
  [
    '#DB2777',
    '#EC4899',
    '#BE185D',
    '#9D174D',
    '#831843',
    '#6C1438',
    '#5A102D',
    '#480B23',
    '#360719',
  ],
  // 6. Cyan Scale (Anchor: #06B6D4)
  [
    '#0891B2',
    '#06B6D4',
    '#0E7490',
    '#155E75',
    '#164E63',
    '#133E53',
    '#0F3143',
    '#0B2433',
    '#081C28',
  ],
  // 7. Orange Scale (Anchor: #F97316)
  [
    '#FDBA74',
    '#F97316',
    '#EA580C',
    '#C2410C',
    '#9A3412',
    '#7C2D12',
    '#5F220E',
    '#4A1A0B',
    '#381308',
  ],
];

// Country code to ISO code mapping
const COUNTRY_CODES = {
  '+1': 'us',
  '+44': 'gb',
  '+91': 'in',
  '+92': 'pk',
  '+93': 'af',
  '+20': 'eg',
  '+27': 'za',
  '+30': 'gr',
  '+31': 'nl',
  '+32': 'be',
  '+33': 'fr',
  '+34': 'es',
  '+39': 'it',
  '+40': 'ro',
  '+41': 'ch',
  '+43': 'at',
  '+45': 'dk',
  '+46': 'se',
  '+47': 'no',
  '+48': 'pl',
  '+49': 'de',
  '+51': 'pe',
  '+52': 'mx',
  '+53': 'cu',
  '+54': 'ar',
  '+55': 'br',
  '+56': 'cl',
  '+57': 'co',
  '+58': 've',
  '+60': 'my',
  '+61': 'au',
  '+62': 'id',
  '+63': 'ph',
  '+64': 'nz',
  '+65': 'sg',
  '+66': 'th',
  '+81': 'jp',
  '+82': 'kr',
  '+84': 'vn',
  '+86': 'cn',
  '+90': 'tr',
  '+94': 'lk',
  '+95': 'mm',
  '+98': 'ir',
  '+212': 'ma',
  '+213': 'dz',
  '+216': 'tn',
  '+218': 'ly',
  '+220': 'gm',
  '+221': 'sn',
  '+222': 'mr',
  '+223': 'ml',
  '+224': 'gn',
  '+225': 'ci',
  '+226': 'bf',
  '+227': 'ne',
  '+228': 'tg',
  '+229': 'bj',
  '+230': 'mu',
  '+231': 'lr',
  '+232': 'sl',
  '+233': 'gh',
  '+234': 'ng',
  '+235': 'td',
  '+236': 'cf',
  '+237': 'cm',
  '+238': 'cv',
  '+239': 'st',
  '+240': 'gq',
  '+241': 'ga',
  '+242': 'cg',
  '+243': 'cd',
  '+244': 'ao',
  '+245': 'gw',
  '+248': 'sc',
  '+249': 'sd',
  '+250': 'rw',
  '+251': 'et',
  '+252': 'so',
  '+253': 'dj',
  '+254': 'ke',
  '+255': 'tz',
  '+256': 'ug',
  '+257': 'bi',
  '+258': 'mz',
  '+260': 'zm',
  '+261': 'mg',
  '+263': 'zw',
  '+264': 'na',
  '+265': 'mw',
  '+266': 'ls',
  '+267': 'bw',
  '+268': 'sz',
  '+269': 'km',
  '+291': 'er',
  '+297': 'aw',
  '+298': 'fo',
  '+299': 'gl',
  '+350': 'gi',
  '+351': 'pt',
  '+352': 'lu',
  '+353': 'ie',
  '+354': 'is',
  '+355': 'al',
  '+356': 'mt',
  '+357': 'cy',
  '+358': 'fi',
  '+359': 'bg',
  '+370': 'lt',
  '+371': 'lv',
  '+372': 'ee',
  '+373': 'md',
  '+374': 'am',
  '+375': 'by',
  '+376': 'ad',
  '+377': 'mc',
  '+378': 'sm',
  '+380': 'ua',
  '+381': 'rs',
  '+382': 'me',
  '+383': 'xk',
  '+385': 'hr',
  '+386': 'si',
  '+387': 'ba',
  '+389': 'mk',
  '+420': 'cz',
  '+421': 'sk',
  '+423': 'li',
  '+500': 'fk',
  '+501': 'bz',
  '+502': 'gt',
  '+503': 'sv',
  '+504': 'hn',
  '+505': 'ni',
  '+506': 'cr',
  '+507': 'pa',
  '+509': 'ht',
  '+591': 'bo',
  '+592': 'gy',
  '+593': 'ec',
  '+595': 'py',
  '+597': 'sr',
  '+598': 'uy',
  '+670': 'tl',
  '+673': 'bn',
  '+674': 'nr',
  '+675': 'pg',
  '+676': 'to',
  '+677': 'sb',
  '+678': 'vu',
  '+679': 'fj',
  '+680': 'pw',
  '+685': 'ws',
  '+686': 'ki',
  '+687': 'nc',
  '+688': 'tv',
  '+691': 'fm',
  '+692': 'mh',
  '+850': 'kp',
  '+852': 'hk',
  '+853': 'mo',
  '+855': 'kh',
  '+856': 'la',
  '+880': 'bd',
  '+886': 'tw',
  '+960': 'mv',
  '+961': 'lb',
  '+962': 'jo',
  '+963': 'sy',
  '+964': 'iq',
  '+965': 'kw',
  '+966': 'sa',
  '+967': 'ye',
  '+968': 'om',
  '+970': 'ps',
  '+971': 'ae',
  '+972': 'il',
  '+973': 'bh',
  '+974': 'qa',
  '+975': 'bt',
  '+976': 'mn',
  '+977': 'np',
  '+992': 'tj',
  '+993': 'tm',
  '+994': 'az',
  '+995': 'ge',
  '+996': 'kg',
  '+998': 'uz'
};

const NIVO_COLORS = [
  // Sequential Schemes
  '#F7FBFF', // blues (lightest)
  '#F7FCF5', // greens (lightest)
  '#FFF5EB', // oranges (lightest)
  '#FCFBFD', // purples (lightest)
  '#FFF5F0', // reds (lightest)

  // Categorical Schemes
  '#41C8CA', // nivo
  '#1F77B4', // category10
  '#7FC97F', // accent
  '#1B9E77', // dark2
  '#A6CEE3', // paired
  '#FBB4AE', // pastel1
  '#B3E2CD', // pastel2
  '#E41A1C', // set1
  '#66C2A5', // set2
  '#8DD3C7', // set3
]

const REPORTS = {
  MEASURES: {
    TASK_COUNT: 'task-count',
  },
};
// Matches Tailwind's `lg` breakpoint — sidebar collapses to drawer below this
const MOBILE_BREAKPOINT = 1024;

export {
  ROOM_TYPE,
  APPLICATION_NAME,
  MOBILE_BREAKPOINT,
  COLOURS,
  PRIORITY_COLORS,
  COLOUR_PALETTE,
  PROJECT_ICON_COLOURS,
  PRIORITY_LABEL,
  PRIORITY_ICON,
  COUNTRY_CODES,
  taskPriority,
  taskStatus,
  customFieldTypes,
  accessStatus,
  fieldTypes,
  dueDateFilterOptions,
  lastUpdatedFilterOptions,
  sectionColors,
  sectionThemeColors,
  ASANA_MIGRATION_VOID_COLORS,
  DASHBOARD_CHART_COLORS,
  DASHBOARD_COLOR_PALETTES,
  NIVO_COLORS,
  REPORTS
}